export class HistoricalPipelineColumns {
    category;
    type;
    properties;
    totalPrice;
    totalGrossFee;
    split;
    striveGrossFee;
    collapsed;

    constructor({category, type = null, data}) {
        let propertiesKey = type ? `TOTAL_${category.toUpperCase()}_${type.toUpperCase()}_PROPERTIES` : `TOTAL_${category.toUpperCase()}_PROPERTIES`;
        let priceKey = type ? `TOTAL_${category.toUpperCase()}_${type.toUpperCase()}_PRICE` : `TOTAL_${category.toUpperCase()}_PRICE`;
        let feeKey = type ? `TOTAL_${category.toUpperCase()}_${type.toUpperCase()}_GROSS_FEE` : `TOTAL_${category.toUpperCase()}_GROSS_FEE`;
        let listSplitKey = type ? `LIST_${category.toUpperCase()}_${type.toUpperCase()}_SPLIT` : `LIST_TOTAL_${category.toUpperCase()}_SPLIT`;
        let buySplitKey = type ? `BUY_${category.toUpperCase()}_${type.toUpperCase()}_SPLIT` : `BUY_TOTAL_${category.toUpperCase()}_SPLIT`;

        switch (type) {
            case 'STNL':
                this.type = 'Single-Tenant';
                this.category = null;
                break;
            case 'MT':
                this.type = 'Multi-Tenant';
                this.category = null;
                break;
            default:
                this.type = null;
                this.category = category;
        }

        this.properties = data[propertiesKey] ? parseInt(data[propertiesKey]) : 0;
        this.totalPrice = data[priceKey] ? parseFloat(data[priceKey]) : 0;
        this.totalGrossFee = data[feeKey]? parseFloat(data[feeKey]) : 0;
        const listSplit = data[listSplitKey] ? parseFloat(data[listSplitKey]) : 0;
        const buySplit = data[buySplitKey] ? parseFloat(data[buySplitKey]) : 0;
        this.split = listSplit + buySplit;
        this.striveGrossFee = this.totalGrossFee - this.split;
        this.collapsed = !!type;
    }
}